<template>
  <b-row>
    <b-col md="12">
      <component-header
        title="Extended Attributes For Profile"
        :hasSearch="false"
        @reload-data="reloadData"
        :hasCreate="true"
        createButtonText="Add New"
        :hasback="false"
        @create-press="addField()"
      />
    </b-col>
    <b-col>
      <b-card>
        <b-row>
          <b-col md="12">
            <b-tabs v-model="tabIndex">
              <b-tab title="Partners">
                <b-container fluid>
                  <b-table
                    :items="partnerItems"
                    :fields="fields"
                    :current-page="currentPage"
                    stacked="md"
                    head-variant="light"
                    show-empty
                    :busy="loading"
                    :outlined="false"
                    small
                    class="headclass mt-2"
                    @filtered="onFiltered"
                  >
                    <template slot="actions" slot-scope="data">
                      <b-button
                        size="sm"
                        class="mr-2 round"
                        variant="primary"
                        @click="editFields(data.item)"
                      >
                        <i class="fas fa-pencil-alt"></i>
                      </b-button>
                      <b-button
                        size="sm"
                        class="mr-2 round"
                        variant="danger"
                        @click="deleteField(data.item._id)"
                      >
                        <i class="fa fa-trash bin"></i>
                      </b-button>
                    </template>

                    <template #row-details="row">
                      <b-card>
                        <ul>
                          <li v-for="(value, key) in row.item" :key="key">
                            <div class="mt-2">{{ key }}: {{ value }}</div>
                          </li>
                        </ul>
                      </b-card>
                    </template>
                  </b-table>

                  <!-- Info modal -->
                  <b-modal
                    :id="infoModal.id"
                    :title="infoModal.title"
                    ok-only
                    @hide="resetInfoModal"
                  >
                    <pre>{{ infoModal.content }}</pre>
                  </b-modal>
                </b-container>
              </b-tab>
              <b-tab title="Customers">
                <b-container fluid>
                  <b-table
                    :items="customerItems"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    stacked="md"
                    head-variant="light"
                    show-empty
                    :outlined="false"
                    small
                    class="headclass mt-2"
                    @filtered="onFiltered"
                  >
                    <template slot="actions" slot-scope="data">
                      <b-button
                        size="sm"
                        class="mr-2 round"
                        variant="primary"
                        @click="editFields(data.item)"
                      >
                        <i class="fas fa-pencil-alt"></i>
                      </b-button>
                      <b-button
                        size="sm"
                        class="mr-2 round"
                        variant="danger"
                        @click="deleteField(data.item._id)"
                      >
                        <i class="fa fa-trash bin"></i>
                      </b-button>
                    </template>

                    <template #row-details="row">
                      <b-card>
                        <ul>
                          <li v-for="(value, key) in row.item" :key="key">
                            {{ key }}: {{ value }}
                          </li>
                        </ul>
                      </b-card>
                    </template>
                  </b-table>

                  <!-- Info modal -->
                  <b-modal
                    :id="infoModal.id"
                    :title="infoModal.title"
                    ok-only
                    @hide="resetInfoModal"
                  >
                    <pre>{{ infoModal.content }}</pre>
                  </b-modal>
                </b-container></b-tab
              >
              <b-tab title="Agents">
                <b-container fluid>
                  <b-table
                    :items="agentItems"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    stacked="md"
                    head-variant="light"
                    show-empty
                    :outlined="false"
                    small
                    class="headclass mt-2"
                    @filtered="onFiltered"
                  >
                    <template slot="actions" slot-scope="data">
                      <b-button
                        size="sm"
                        class="mr-2 round"
                        variant="primary"
                        @click="editFields(data.item)"
                      >
                        <i class="fas fa-pencil-alt"></i>
                      </b-button>
                      <b-button
                        size="sm"
                        class="mr-2 round"
                        variant="danger"
                        @click="deleteField(data.item._id)"
                      >
                        <i class="fa fa-trash bin"></i>
                      </b-button>
                    </template>

                    <template #row-details="row">
                      <b-card>
                        <ul>
                          <li v-for="(value, key) in row.item" :key="key">
                            {{ key }}: {{ value }}
                          </li>
                        </ul>
                      </b-card>
                    </template>
                  </b-table>

                  <!-- Info modal -->
                  <b-modal
                    :id="infoModal.id"
                    :title="infoModal.title"
                    ok-only
                    @hide="resetInfoModal"
                  >
                    <pre>{{ infoModal.content }}</pre>
                  </b-modal>
                </b-container></b-tab
              >
            </b-tabs>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-modal
      id="modalAdd"
      v-model="showModal"
      centered
      title="Add New Field"
      header-class="border-0 header-text"
      footer-class="border-0 footer-button"
      modal-class="p-3"
      hide-footer
      ref="field-modal"
    >
      <b-row>
        <b-col md="6" class="pb-0">
          <b-form-input
            placeholder="Enter Field Name"
            v-model="formData.fieldName"
          ></b-form-input>
        </b-col>
        <b-col md="6" class="pb-0">
          <b-form-select
            v-model="formData.dataType"
            placeholder="Select Data Type"
            :options="dataTypes"
          ></b-form-select
        ></b-col>
        <b-col md="12">
          <b-form-checkbox
            id="checkbox-1"
            class="mt-2"
            v-model="formData.isRequired"
            name="checkbox-1"
            variant="success"
          >
            Make it mandatory
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="1"></b-col>
        <b-col md="5">
          <b-button variant="outline-primary" block @click="showModal = false"
            >CANCEL</b-button
          ></b-col
        >
        <b-col md="5">
          <b-button variant="primary" block @click="saveField">SAVE</b-button>
        </b-col>
        <b-col md="1"></b-col>
      </b-row>
    </b-modal>

    <!--Edit-->
    <b-modal
      id="modalAdd"
      v-model="showEditModal"
      centered
      title="Update Field"
      header-class="border-0 header-text"
      footer-class="border-0 footer-button"
      modal-class="p-3"
      hide-footer
      ref="field-modal"
    >
      <b-row>
        <b-col md="6" class="pb-0">
          <b-form-input
            placeholder="Enter Field Name"
            v-model="formData.fieldName"
          ></b-form-input>
        </b-col>
        <b-col md="6" class="pb-0">
          <b-form-select
            v-model="formData.dataType"
            placeholder="Select Data Type"
            :options="dataTypes"
          ></b-form-select
        ></b-col>
        <b-col md="12">
          <b-form-checkbox
            id="checkbox-1"
            class="mt-2"
            v-model="formData.isRequired"
            name="checkbox-1"
            variant="success"
          >
            Make it mandatory
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="1"></b-col>
        <b-col md="5">
          <b-button
            variant="outline-primary"
            block
            @click="showEditModal = false"
            >CANCEL</b-button
          ></b-col
        >
        <b-col md="5">
          <b-button variant="primary" block @click="updateField">SAVE</b-button>
        </b-col>
        <b-col md="1"></b-col>
      </b-row>
    </b-modal>
  </b-row>
</template>
<script>
import profile from "@/components/profile/profileCategory";
import currentUserData from "@/mixins/currentUser";
import { mapState } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  components: {
    profile,
    ComponentHeader,
  },
  mixins: [currentUserData],
  data() {
    return {
      currentUserData: "",
      cashOnDelivery: false,
      onlinePayment: false,
      maxAllowedDevices: "",
      firstRow: [],
      secondRow: [],
      thirdRow: [],
      tenants: [],
      tabIndex: 0,
      partnerItems: [],
      agentItems: [],
      customerItems: [],
      showModal: false,
      loading: false,
      formData: {
        dataType: null,
        fieldName: "",
        isRequired: false,
      },
      fields: [
        {
          key: "fieldName",
          label: "Field Name",
          sortable: true,
          sortDirection: "desc",
          tdClass: "pt-2",
        },
        {
          key: "dataType",
          label: "Data Type",
          class: "text-center",
          tdClass: "pt-2",
        },
        {
          key: "isRequired",
          label: "Mandatory",
          class: "text-center",
          tdClass: "pt-2",
          formatter: (value, key, item) => {
            return value ? "Yes" : "No";
          },
        },
        { key: "actions", label: "Action" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 150,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      showEditModal: false,
      filterOn: [],
      deletePayload: { data: {} },
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      dataTypes: [
        { value: null, text: "Select Data Type" },
        { value: "Integer", text: "Integer" },
        { value: "Decimal", text: "Decimal" },
        { value: "String", text: "String" },
        { value: "Date", text: "Date" },
        { value: "Boolean", text: "Boolean" },
        { value: "File", text: "File" },
      ],
    };
  },
  computed: {
    ...mapState({
      extendedList: (state) => state.tenant.extendedList,
    }),
  },
  methods: {
    async reloadData() {
      this.loading = true;
      await this.getAttributeList();
      this.loading = false;
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-primary", "text-light"];
      } else {
        return ["bg-light", "text-info"];
      }
    },
    deleteField(id) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Delete",
        })
        .then((result) => {
          if (result.value) {
            this.deleteExtendedField(id);
          }
        });
    },
    async getAttributeList() {
      this.$store.dispatch("tenant/setExtendedAttributeList").then(() => {
        this.partnerItems = this.extendedList.externalInfoPartner;
        this.agentItems = this.extendedList.externalInfoAdmin;
        this.customerItems = this.extendedList.externalInfoCustomer;
      });
    },
    checkRow() {
      this.firstRow = [];
      this.secondRow = [];
      this.thirdRow = [];
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    addField() {
      this.formData = {
        dataType: null,
        fieldName: "",
        isRequired: false,
      };
      this.showModal = true;
    },
    editFields(item) {
      this.showEditModal = true;
      this.formData = item;
    },

    callPostApi(payload) {
      this.$store.dispatch("tenant/saveExtendedData", payload).then(() => {
        (this.formData = {
          dataType: null,
          fieldName: "",
          isRequired: false,
        }),
          this.$swal({
            title: "Success",
            text: "Field Added Successfully!!",
            type: "success",
          });
        this.getAttributeList();
      });
    },
    callPutApi(payload) {
      this.$store.dispatch("tenant/editExtendedItem", payload).then(() => {
        (this.formData = {
          dataType: null,
          fieldName: "",
          isRequired: false,
        }),
          this.$swal({
            title: "Success",
            text: "Field Updated Successfully!!",
            type: "success",
          });
      });
    },
    callDeleteApi(payload) {
      this.$store.dispatch("tenant/deleteExtendedItem", payload).then(() => {
        this.$swal({
          title: "Success",
          text: "Extended Attribute Deleted Successfully!!",
          type: "success",
        });
        this.getAttributeList();
      });
    },
    saveField() {
      if (this.formData.dataType != null && this.formData.fieldName != "") {
        switch (this.tabIndex) {
          case 0: {
            this.showModal = false;
            let payload = { externalInfoPartner: this.formData };
            this.callPostApi(payload);
            break;
          }
          case 1: {
            this.showModal = false;
            let payload = { externalInfoCustomer: this.formData };
            this.callPostApi(payload);
            break;
          }
          case 2: {
            this.showModal = false;
            let payload = { externalInfoAdmin: this.formData };
            this.callPostApi(payload);
            break;
          }
        }
      } else {
        this.$swal({
          title: "Error",
          text: "Enter Required Fields",
          type: "warning",
        });
      }
    },
    updateField() {
      if (this.formData.dataType != null && this.formData.fieldName != "") {
        let payload = {};
        this.showEditModal = false;
        switch (this.tabIndex) {
          case 0: {
            let id = this.formData._id;
            delete this.formData._id;
            payload = {
              data: { externalInfoPartner: this.formData },
              id: id,
            };
            break;
          }
          case 1: {
            let id = this.formData._id;
            delete this.formData._id;
            payload = {
              data: { externalInfoCustomer: this.formData },
              id: id,
            };
            break;
          }
          case 2: {
            let id = this.formData._id;
            delete this.formData._id;
            payload = {
              data: { externalInfoAdmin: this.formData },
              id: id,
            };
            break;
          }
        }

        this.callPutApi(payload);
      } else {
        this.$swal({
          title: "Error",
          text: "Enter Required Fields",
          type: "warning",
        });
      }
    },
    deleteExtendedField(id) {
      let idObj = { id: id };
      switch (this.tabIndex) {
        case 0: {
          this.deletePayload.data = {
            externalInfoPartner: idObj,
          };
          break;
        }
        case 1: {
          this.deletePayload.data = {
            externalInfoCustomer: idObj,
          };
          break;
        }
        case 2: {
          this.deletePayload.data = {
            externalInfoAdmin: idObj,
          };
          break;
        }
      }
      // deletePayload = JSON.parse(deletePayload);
      this.callDeleteApi(this.deletePayload);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  mounted() {
    this.loading = true;
    this.getAttributeList();
    this.loading = false;
    this.totalRows = this.items.length;
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>
<style>
.language-button button {
  width: 160px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  font-size: 14px;
}
.card-img-top {
  height: 70px;
  width: auto;
  max-width: 100%;
}
.card-body {
  padding: 15px;
}
.card-footer {
  border-top: 2px dashed #c8d1d7;
}
@media (max-width: 768px) {
  .language-button button {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
.center {
  text-align: center;
}
.headclass .thead-light th {
  color: var(--secondary);
  background-color: #f1f3fa;
  border-color: #e3eaef;
  padding: 1rem;
}
.headclass .thead-light {
  border-radius: 10px;
}
.headclass td {
  border-top: 1px solid #f1f5f8;
}
.description {
  color: black;
}
.round {
  border-radius: 50%;
  height: 30px;
  width: 30px;
  padding: 0;
}
.nav-tabs .nav-link.active {
  color: var(--primary);
}
.header-text .modal-title {
  font-size: 1.2rem;
  color: var(--primary);
  text-align: left;
}
.modal-content {
  padding: 1rem;
}
select.form-control:not([size]):not([multiple]) {
  height: calc(3.2125rem - 6px);
}
</style>
